import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { clearAll, getCookie, setCookie } from "../../../shared/helpers";
import {
  canAccessProjectsPlan,
  canUseSubscriptionFeatures,
  getCreditsBalancePayload,
  isSkillRadarUser,
} from "../../../shared/billing";
import { useUserProfile } from "../../../redux/selectors/profileSelectors";
import { Auth } from "../../../config/aws-exports";
import history from "../../../routes/history";
import { useSelector, useDispatch } from "react-redux";
import {
  updateUserInfo,
  resetUserProfile,
  resetCompanyProfileDetails,
  getAbsAccounts,
  getAllInterviews,
  getFavorites,
  toggleSearchTrue,
} from "../../../redux/actions";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { Col, Row, Menu, Modal, Tooltip } from "antd";
import logo from "../../../assets/img/logo.png";
import "./ProfileHeader.css";
import CurrencyMenu from "./CurrencyMenu";
import rupeeCurrencyIcon from "../../../assets/img/rupee.png";
import dollarCurrencyIcon from "../../../assets/img/dollar.png";
import pesoCurrencyIcon from "../../../assets/img/claritypeso.png";
import AccountsModal from "../../Accounts/AccountsModal";
import Notifications from "../../Notification/Notifications";

const ProfileHeader = (props) => {
  const dispatch = useDispatch();
  const userProfile = useUserProfile();
  const canShowPrivateTalent = isSkillRadarUser(userProfile);

  let [profileData, setProfileData] = useState("");
  const PreferredCurrency = useSelector(
    (state) => state.profileReducer?.user?.profile?.PreferredCurrency
  );
  const usertag = useSelector((state) => state.TagReduer?.userTag?.data);
  const { ABS } = useSelector((state) => state.profileReducer);
  const favorites = useSelector((state) => state.favoritesReducer.details.favorites);
  const interviews = useSelector((state) => state.getAllInterviewsReducer.interviews);
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalancePayload = getCreditsBalancePayload(creditsBalance);
  const planCode =
    creditsBalancePayload?.planCode || creditsBalancePayload?.productCode || '';
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures(userProfile);
  const isTeamMember =
    userProfile?.MasterAccountId !== null && userProfile?.MasterAccountId !== undefined;
  const isRestrictedPlan =
    subscriptionFeaturesEnabled &&
    !isTeamMember &&
    ['Free', 'STARTER_MONTHLY', 'STARTER_YEARLY'].includes(planCode);
  const canShowProjects = canAccessProjectsPlan(creditsBalance);
  const [showCurrency, setshowCurrency] = useState(false);
  const [isCurrencyModelVisible, setIsCurrencyModelVisible] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

   useEffect(() => {
      dispatch(getAllInterviews());
      dispatch(getFavorites(1, windowDimensions.width > 768 ? "24" : "20",'web'))
    }, []);

  const [btnVisible, setBtnVisible] = useState(false);

  const [currencyType, setCurrencyType] = useState(
    PreferredCurrency ? PreferredCurrency : "USD"
  );

  const notificationHandler = (Icon) => {
    // setShowSearchBar(false);
    if (windowDimensions.width < 768) {
      history.push({ pathname: "/notification", state: { Icon: Icon } });
    } else {
      history.push("/conversations", Icon);
    }
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onLogOut = async () => {
    try {
      setCookie("token", "");
      setCookie("RememberMe", "false");
      setCookie("impersonationid", "");
      setCookie("finishProfile", "");
      clearAll();
      props.sendAuthToken(null);
      // history.push("/home");
      // window.location.replace("/employer/login");
      localStorage.removeItem("redirectUrl");
      dispatch(resetUserProfile());
      dispatch(resetCompanyProfileDetails());
      // props.hide();
      localStorage.removeItem("userProfile");

      props.changeStage("");
      await Auth.signOut();
      window.location.replace("/employer/login");
    } catch (error) {
      window.location.replace("/employer/login");
    }
  };

  useEffect(async () => {
    setProfileData(await JSON.parse(localStorage.getItem("userProfile")));
  }, []);

  const currencyList = [
    {
      name: "United States Dollar",
      code: "USD",
      symbol: dollarCurrencyIcon,
    },
    {
      name: "Indian Rupee",
      code: "INR",
      symbol: rupeeCurrencyIcon,
    },
    {
      name: " Canadian Dollar",
      code: "CAD",
      symbol: dollarCurrencyIcon,
    },
    {
      name: " Mexican Peso",
      code: "PESO",
      symbol: pesoCurrencyIcon,
    },
  ];

  const showCurrencyModal = () => {
    setIsCurrencyModelVisible(true);
  };

  const closeCurrencyModal = () => {
    setIsCurrencyModelVisible(false);
  };

  const { symbol } = currencyList.filter(
    ({ code }) => code === currencyType
  )[0] ?? {};

  return (
    <Menu >
      {btnVisible && (
        <AccountsModal
          btnVisible={btnVisible}
          setBtnVisible={setBtnVisible}
          hide={props.hide}
          currentAccountName={userProfile?.Profiles?.PreferredName}
          currentAccountId={userProfile?.AccountId}
          visible={props.visible}
          username={userProfile?.Profiles?.FirstName}
          email={userProfile?.EmailAddress}
          ABS={ABS}
        />
      )}
      <section className="profileDropHeader" style={{ height: windowDimensions.width > 786 ? "auto" : "70vh"}} onClick={() => props.hide(props.visible)}>
        <div className="abs-div">
          {/* <div onClick={() => history.push("/profile")}>Profile</div> */}
            {usertag?.length > 0 && (
              <>
                <Row
                  onClick={() => {
                    dispatch(getAbsAccounts());
                    props.hide(props.visible);
                    setBtnVisible(true);
                  }}
                  className="switch-div"
                >
                  <Col xs={12} className="switch-text">
                    Switch account
                  </Col>
                </Row>

                <Row>
                  <Col
                    style={{
                      // textAlign: "right",
                      color: "#666666",
                      fontSize: '11px',
                      fontWeight: "400",
                      marginTop: "-20px",
                    }}  
                    // xs={12}
                  >
                    {`${userProfile?.Profiles?.FirstName} ${userProfile?.Profiles?.LastName}`}
                  </Col>
                </Row>
                <p
                  className="profileDivider"
                  style={{
                    margin:
                      windowDimensions.width < 786
                        ? "-6px 0px 2px"
                        : "-10px 0px 1px",
                  }}
                ></p>
              </>
            )}
        </div>
         {/* <div onClick={() => notificationHandler("message")}>Inbox</div> */}
        <div className="profileDropFirst">
          {windowDimensions.width < 786 && (
            <>
              <div
                className="section-title"
                onClick={() => history.push("/employerdashboard")}
              >
                Dashboard
              </div>
              {canShowProjects && (
                <div
                  className="section-title"
                  onClick={() => history.push("/manage-projects")}
                >
                  Projects
                </div>
              )}
              {canShowPrivateTalent && (
                <div
                  className="section-title"
                  onClick={() => history.push("/internal")}
                >
                  Private Talent
                </div>
              )}
              <div
                className="section-title"
                onClick={() => history.push("/create-job")}
              >
                Post a Job
              </div>
              <div
                className="section-title"
                onClick={() => history.push("/joblisting")}
              >
                Manage jobs
              </div>
              <p
                className="profileDivider"
                style={{
                  margin: windowDimensions.width < 786 ? "4px 0px 4px 0px" : "",
                }}
              ></p>
            </>
          )}
        </div>
        <div className="profileDropFirst">
          <div onClick={() => {
            dispatch(toggleSearchTrue())
            history.push("/managecandidate")
            }}>
            <Tooltip 
            overlayInnerStyle={{
              width: '220px',
              fontSize: '11px',
              fontWeight: '400',
            }}
            overlayStyle={{
              position: 'fixed',
            }}
            placement='bottomLeft'
            title={'Track the status of all the bids that are placed to the candidates and bids that are received by the candidates here'}
            className='cts-tooltip'
            >
              Candidate tracking system
            </Tooltip>
          </div>
          <div
            className="green-text"
            onClick={() => {
              dispatch(toggleSearchTrue())
              history.push("/mymatches")
            }}
          >
            Candidate matches
          </div>
          {subscriptionFeaturesEnabled && (
            <div onClick={() => {
              dispatch(toggleSearchTrue())
              history.push("/manage-invites")}
              }>
              Manage Invites
            </div>
          )}
          <div onClick={() => {
            dispatch(toggleSearchTrue())
            history.push("/view-interviews")}
            }>
            {`Interview${interviews?.length > 1 ? '(s)' : ''}`}
          </div>
          {/* <div className="interviewDropdown">
            <span>Bids</span>
            <span className="spanNumber">5</span>
          </div> */}
          {/* <div onClick={() => history.push("/candidatemarketing")}>
            Candidate market
          </div> */}

          <div onClick={() => {
             dispatch(toggleSearchTrue())
            history.push("/myfavourites")}
            }>
            {`Favorite${favorites?.length > 1 ? '(s)' : ''}`}
          </div>
        </div>

        <div className="myProfileDropdown">
          {/* <h4>My Profile</h4> */}
          <p
            className="profileDivider"
            style={{
              margin: windowDimensions.width < 786 ? "20px 0px 16px 0px" : "",
            }}
          ></p>
          <div className="profileDropSecond">
            <div onClick={() => {
              dispatch(toggleSearchTrue())
              history.push("/companyprofile")
              }}>
              Company profile
            </div>
            <div
              className="section-title"
              onClick={() =>
                {
                  dispatch(toggleSearchTrue())
                  history.push({
                  pathname: "/myprofile",
                  state: {
                    previous: "drawer",
                    profileEdit: true,
                  },
                })
              }
              }
            >
              My profile
            </div>
            {subscriptionFeaturesEnabled && <div
              className={windowDimensions.width < 786 ? "section-title" : ""}
              onClick={() => {
                props.hide(props.visible);
                dispatch(toggleSearchTrue());
                history.push("/billing");
              }}
            >
              Invoice
            </div>}
          </div>
        </div>
        <div className="myEarningsDropdown">
          {/* <h4>Manage</h4> */}
          <p
            className="profileDivider"
            style={{
              margin: windowDimensions.width < 786 ? "20px 0px 16px 0px" : "",
            }}
          ></p>
          <div className="profileDropThird">
            {/* <div onClick={() => history.push("/joblisting")}>Gigs</div> */}
            {!isRestrictedPlan && <div onClick={() => {
              dispatch(toggleSearchTrue());
              history.push("/myteams")}}
              >Team</div>}
            <div onClick={onLogOut}>Sign out</div>
            {/* <div onClick={() => history.push("/managecandidate")}>
              Candidate tracking system
            </div> */}
            {/* <div onClick={() => history.push("/timesheet/list")}>
              Candidate timesheet
            </div> */}
            {/* <div className="resumeCredentialing green-text">
              Refer & earn more
            </div> */}
          </div>
        </div>
        {/* <div className="generalDropdown"> */}
        {/* {profileData?.MasterAccountId == null && ( */}
        {/* <>
              <h4>General</h4>
              <div className="profileDivider"></div>
              <div className="profileDropThird"> */}
        {/* <div onClick={() => history.push("/subscriptions-main")}>
              Subscription
            </div> */}
        {/* <div onClick={() => history.push("/managespends")}>Billings</div> */}
        {/* </div>
            </> */}
        {/* )} */}
        {/* <div className="profileDivider"></div> */}
        {/* <div className="profileDropFourth"> */}
        {/* {window.innerWidth > 1000 ? (
              <>
                <div
                  onClick={showCurrencyModal}
                  className="Currency_Type_And_Symbol"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{ height: "17px", width: "17px" }}
                    src={symbol}
                    alt=""
                  />
                  <span>{currencyType}</span>
                </div>
                <Modal
                  visible={isCurrencyModelVisible}
                  bodyStyle={{ padding: 0 }}
                  width="25rem"
                  closable={false}
                  footer={null}
                  maskClosable={true}
                  centered={true}
                  onCancel={closeCurrencyModal}
                >
                  <CurrencyMenu
                    currencyType={currencyType}
                    setCurrencyType={setCurrencyType}
                    closeCurrencyModal={closeCurrencyModal}
                    currencyList={currencyList}
                  />
                </Modal>
              </>
            ) : (
              <>
                <div className="Currency_Dropdown_Mobile_View">
                  <Row
                    onClick={(e) => {
                      e.stopPropagation();
                      setshowCurrency(!showCurrency);
                    }}
                  >
                    <Col span={21}>
                      <div className="Currency_Type_And_Symbol">
                        <img src={symbol} alt="" />
                        <span>{currencyType}</span>
                      </div>
                    </Col>
                    <Col>
                      {showCurrency ? (
                        <span className="Arrow_Currency_Change">
                          <UpOutlined />
                        </span>
                      ) : (
                        <span className="Arrow_Currency_Change">
                          <DownOutlined />
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
                {showCurrency ? (
                  <CurrencyMenu
                    currencyType={currencyType}
                    setCurrencyType={setCurrencyType}
                    closeCurrencyModal={closeCurrencyModal}
                    currencyList={currencyList}
                    setshowCurrency={setshowCurrency}
                  />
                ) : null}
              </>
            )} */}
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
      </section>
    </Menu>
  );
};
const mapStateToProps = (state) => {
  return {
    profile: state.profileReducer.user.name,
    error: state.profileReducer.error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendAuthToken: (params) => {
      dispatch(updateUserInfo(params)); // action dispatched
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
